import { deviceGet } from "api/device";
import { Device } from "api/types/device";
import {
  deviceConfiguration,
  DeviceConfiguration,
} from "models/devices/configuration";
import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { setLoading } from "store/appSlice";
import Installer from "./components/installer";
import Raws from "./components/raws";
import DeviceRaw from "./components/device";
import Flattend from "./components/flattend";
import { JOB_STATUS } from "widgets/dialogs/jobStatus";
import useViewportDimensions, {
  SecondaryHeightLayout,
} from "hooks/viewport-dimensions";
import { Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/tabs";
import { useTranslation } from "react-i18next";
import Aggregates from "./components/aggregates";

const DevTools = () => {
  const { dimensions } = useViewportDimensions();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  // Extract the filter parameter
  const snr = searchParams.get("snr");
  const job = searchParams.get("job");
  const state = searchParams.get("status");

  const [device, setDevice] = useState<Device>(null);
  const [config, setConfig] = useState<DeviceConfiguration>(null);

  const fetchData = async () => {
    dispatch(setLoading(true));
    const { data, status, isLoading, error } = await deviceGet(snr);
    dispatch(setLoading(isLoading));
    if (!error && status && status === 200) {
      const config = deviceConfiguration.getDeviceByTag(data.model);
      setConfig(config);
      setDevice(data);
    }
  };

  useEffect(() => {
    if (snr) {
      fetchData();
    }
  }, [snr]);

  const cardHeight = useCallback(() => {
    return dimensions.contentHeight - 16;
  }, []);

  return (
    <>
      {config && (
        <SecondaryHeightLayout>
          <div className="flex h-full flex-col gap-4 lg:flex-row">
            <div className="flex h-full flex-col gap-4 lg:w-1/3">
              <div
                style={{
                  height: (cardHeight() * 1.2) / 3,
                }}
              >
                <Installer
                  device={device}
                  config={config}
                  job={job}
                  status={state as JOB_STATUS}
                />
              </div>
              <div style={{ height: cardHeight() - (cardHeight() * 1.2) / 3 }}>
                <Flattend device={device} config={config} />
              </div>
            </div>

            <Tabs
              variant="plain"
              isLazy
              className="flex w-full flex-col gap-4 rounded-2xl bg-white  p-4 lg:w-2/3"
            >
              <TabList className="rounded-lg border-2 border-primary">
                <Tab className="min-w-36 gap-1 border-r-2 border-primary p-1 text-primary aria-selected:bg-background-50 aria-selected:text-white">
                  {t("tabs.dev.tools.device")}
                </Tab>
                <Tab className="min-w-36 gap-1 border-r-2 border-primary  p-1 text-primary aria-selected:bg-background-50 aria-selected:text-white">
                  {t("tabs.dev.tools.raw")}
                </Tab>
                <Tab className="min-w-36 gap-1 border-r-2 border-primary p-1 text-primary aria-selected:bg-background-50 aria-selected:text-white">
                  {t("tabs.dev.tools.aggregates")}
                </Tab>
              </TabList>
              <TabPanels className="-mt-4">
                <TabPanel>
                  <DeviceRaw device={device} config={config} />
                </TabPanel>
                <TabPanel>
                  <Raws device={device} config={config} />
                </TabPanel>
                <TabPanel>
                  <Aggregates device={device} config={config} />
                </TabPanel>
              </TabPanels>
            </Tabs>
          </div>
        </SecondaryHeightLayout>
      )}
    </>
  );
};

export default DevTools;
